import styles from './StepTourPopover.module.less';
import React, { useEffect, useState } from 'react';
import { CloseOutlined } from '@ant-design/icons';
import { usePopper } from 'react-popper';
import { Popover } from 'antd';
import { isMobile } from 'react-device-detect';

interface StepTourPopoverI {
  refElement: HTMLElement;
  content: string;
  positionPopper: 'top' | 'bottom' | 'bottom-end' | 'top-start';
  positionPopover: 'top' | 'bottom' | 'bottomRight' | 'topLeft';
  onCurrentStep?: (fn: (index: number) => number) => void;
}

function StepTourPopover(props: StepTourPopoverI) {
  const [popperElement, setPopperElement] = useState(null);
  const [visible, setVisible] = useState(true);
  const { styles: style, attributes } = usePopper(props.refElement, popperElement, {
    placement: props.positionPopper,
  });
  const content = (
    <div className={`${styles['content__container']}`}>
      <div className={`${styles['content__text']}`}>{props.content}</div>
      <div className={`${styles['content_icon-close']}`}>
        <CloseOutlined
          className="cursor-pointer"
          onClick={() =>
            isMobile ? props?.onCurrentStep?.((state) => state + 1) : setVisible(false)
          }
        />
      </div>
    </div>
  );

  return (
    <>
      {/*// @ts-ignore */}
      <div ref={setPopperElement} style={style.popper} {...attributes.popper}>
        <Popover placement={props.positionPopover} content={content} visible={visible} />
      </div>
    </>
  );
}

export default StepTourPopover;
